
import { FreelancerProps } from "@/components/freelancers/FreelancerCard";

export const freelancers: FreelancerProps[] = [
  {
    id: "1",
    name: "Alex Johnson",
    avatar: "https://randomuser.me/api/portraits/men/32.jpg",
    title: "Senior Frontend Developer",
    rating: 4.9,
    dailyRate: 65,
    location: "San Francisco, USA",
    skills: ["React", "TypeScript", "Next.js", "Tailwind CSS", "GraphQL"],
    completedJobs: 87,
    successRate: 98,
    description: "I specialize in building responsive, high-performance web applications with modern JavaScript frameworks. Over 8 years of experience working with startups and enterprise clients.",
    availability: "available",
    isVerified: true
  },
  {
    id: "2",
    name: "Maya Patel",
    avatar: "https://randomuser.me/api/portraits/women/44.jpg",
    title: "UI/UX Designer",
    rating: 4.8,
    dailyRate: 55,
    location: "London, UK",
    skills: ["Figma", "Adobe XD", "UI Design", "User Research", "Prototyping"],
    completedJobs: 64,
    successRate: 96,
    description: "Creative designer with a passion for creating intuitive and engaging user experiences. I combine data-driven insights with beautiful aesthetics to deliver exceptional digital products.",
    availability: "next-week",
    isVerified: true
  },
  {
    id: "3",
    name: "David Kim",
    avatar: "https://randomuser.me/api/portraits/men/17.jpg",
    title: "Backend Engineer",
    rating: 4.7,
    dailyRate: 70,
    location: "Seoul, South Korea",
    skills: ["Node.js", "Python", "AWS", "MongoDB", "Docker", "Kubernetes"],
    completedJobs: 52,
    successRate: 95,
    description: "Specialized in building scalable backend systems and APIs. I focus on creating efficient, maintainable code with comprehensive test coverage and documentation.",
    availability: "available",
    isVerified: false
  },
  {
    id: "4",
    name: "Sofia Rodriguez",
    avatar: "https://randomuser.me/api/portraits/women/63.jpg",
    title: "Full Stack Developer",
    rating: 4.9,
    dailyRate: 75,
    location: "Barcelona, Spain",
    skills: ["React", "Node.js", "PostgreSQL", "TypeScript", "Redis", "AWS"],
    completedJobs: 93,
    successRate: 99,
    description: "Full-stack developer with expertise in both frontend and backend technologies. I build complete web applications from concept to deployment with a focus on performance and user experience.",
    availability: "next-month",
    isVerified: true
  },
  {
    id: "5",
    name: "James Wilson",
    avatar: "https://randomuser.me/api/portraits/men/52.jpg",
    title: "Mobile App Developer",
    rating: 4.6,
    dailyRate: 60,
    location: "Toronto, Canada",
    skills: ["React Native", "Flutter", "Firebase", "Swift", "Kotlin"],
    completedJobs: 41,
    successRate: 94,
    description: "Experienced mobile developer specialized in cross-platform and native application development. I build beautiful, performant apps that users love.",
    availability: "available",
    isVerified: false
  },
  {
    id: "6",
    name: "Emma Chen",
    avatar: "https://randomuser.me/api/portraits/women/29.jpg",
    title: "DevOps Engineer",
    rating: 4.8,
    dailyRate: 80,
    location: "Sydney, Australia",
    skills: ["AWS", "Terraform", "Docker", "Kubernetes", "CI/CD", "Jenkins"],
    completedJobs: 38,
    successRate: 97,
    description: "DevOps specialist focused on automating and optimizing infrastructure. I help teams implement efficient deployment pipelines and robust monitoring systems.",
    availability: "next-week",
    isVerified: true
  },
  {
    id: "7",
    name: "Omar Hassan",
    avatar: "https://randomuser.me/api/portraits/men/71.jpg",
    title: "Data Scientist",
    rating: 4.7,
    dailyRate: 85,
    location: "Dubai, UAE",
    skills: ["Python", "TensorFlow", "PyTorch", "SQL", "Data Visualization"],
    completedJobs: 29,
    successRate: 96,
    description: "Data scientist with a background in machine learning and statistical analysis. I transform complex data into actionable insights and predictive models.",
    availability: "next-month",
    isVerified: false
  },
  {
    id: "8",
    name: "Lena Schmidt",
    avatar: "https://randomuser.me/api/portraits/women/12.jpg",
    title: "Blockchain Developer",
    rating: 4.9,
    dailyRate: 95,
    location: "Berlin, Germany",
    skills: ["Solidity", "Ethereum", "Web3.js", "Smart Contracts", "DeFi"],
    completedJobs: 22,
    successRate: 99,
    description: "Blockchain specialist with experience in developing decentralized applications and smart contracts. I help companies leverage the power of blockchain technology.",
    availability: "available",
    isVerified: true
  },
  {
    id: "9",
    name: "Ryan Thompson",
    avatar: "https://randomuser.me/api/portraits/men/89.jpg",
    title: "WordPress Developer",
    rating: 4.6,
    dailyRate: 45,
    location: "Melbourne, Australia",
    skills: ["WordPress", "PHP", "JavaScript", "WooCommerce", "Theme Development"],
    completedJobs: 118,
    successRate: 95,
    description: "WordPress expert specializing in custom theme and plugin development. I create tailored solutions that are both powerful and easy to maintain.",
    availability: "next-week",
    isVerified: false
  }
];
